import React, { Component } from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { appRoutes, privateRoutes } from "./constants/routes";
import PrivateRoute from "./components/CommanComponents/securedRoutes";
import PageNotFound from "./components/CommanComponents/PageNotFound";
import { useTranslation, withTranslation } from "react-i18next";
import ProductionHelmetTag from "./components/CommanComponents/ProductionHelmetTag";
import apiCall, { METHOD } from "./constants/baseUrl";
import { getServerType } from "./constants/apiParams";
import TestServerHelmetTag from "./components/CommanComponents/TestServerHelmetTag";
import { getValueFromLocalStorage, saveDatatoLocalStorage } from "./util/utils";
import { css } from "glamor";



export const toastSuccessOption = {
    className: css({
      background: "#A2C037 !important",
        color: "white !important",
      })
}


export const toastErrorOption = {
  className: css({
    background: "#B31218 !important",
    color: "white !important",
  })
}


export const toastInfoOption = {
  className: css({
    background: "#1E8DCB !important",
    color: "white !important",
  })
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      server_mode: "",
      isLoading: false,
    };
  }

  

  componentDidMount() {
    const server_type = getValueFromLocalStorage("server_type");
    if (!server_type) {
      apiCall(
        METHOD.QUERY,
        getServerType(),
        (data) => {
          saveDatatoLocalStorage("server_type", data.value);
          this.setState({
            server_mode: data.value,
          });
        },
        (isLoading) => {
          this.setState({ isLoading });
        },
        (data) => { }
      );
    } else {
      this.setState({
        server_mode: server_type,
      });
    }
  }
  
  render() {
    const { server_mode, isLoading } = this.state;
    return (
      <React.Fragment >
        {!isLoading && (
          <React.Fragment>
            {server_mode == "TEST" ? (
              <TestServerHelmetTag />
            ): (
                <ProductionHelmetTag />
            )}
            <Router>
              <Switch>
                {appRoutes.map((routeProps, index) => (
                  <Route key={index} {...routeProps} />
                ))}
                {privateRoutes.map((routeProps, index) => {
                  return <PrivateRoute key={index} {...routeProps} />;
                })}
                <Route component={PageNotFound} />
              </Switch>
            </Router>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
export default withTranslation()(App);

